export const iconFontAwesomeCharityLeaf = (
	<i className="fa-solid fa-leaf"></i>
);
